import type { MyClubOnboardingStep } from "@repo/shared/myClub";

import { UsedFeature } from "../../../redux/user/userSlice";
import axios from "../../privateApi";

export const postUsedFeature = async (feature: UsedFeature) => {
  const res = await axios.post("/users/used-features", { feature: feature });
  return res.data;
};

/** Takes a My Club onboarding step back off the account: it was unticked. */
export const deleteUsedFeature = async (feature: MyClubOnboardingStep) => {
  const res = await axios.delete(`/users/used-features/${feature}`);
  return res.data;
};
